import { EChatActionTypes, IOpenChatPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openChat = actionGenerator<EChatActionTypes.Open, IOpenChatPayload>(EChatActionTypes.Open);
export const closeChat = actionGenerator<EChatActionTypes.Close>(EChatActionTypes.Close);
